import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../context/LanguageContext";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import FormContainer from "../../../components/formContainer/FormContainer";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import { StyledInput } from "../../../styles/InputStyles";
import { StyledFlexItem, StyledFlexRow } from "../../../styles/LayoutStyles";
import Select from "../../../components/select/main/Select";
import MultiSelect from "../../../components/select/main/multi/MultiSelect";
import EntityTranslationsContainer from "../../../components/entityTranslationsContainer/EntityTranslationsContainer";
import LocationFormSelect from "../../../components/select/custom/location/form/LocationFormSelect";

function VisitorTypePageView({
  visitorTypeData,
  visitor_type,
  departments,
  fields,
  flows,
  layouts,
  onDepartmentChange,
  onLocationIdChange,
  onNameChange,
  onOrderChange,
  onEarliestTimeChange,
  onLatestTimeChange,
  onReturningChange,
  onRequiresApprovalChange,
  onIdentifierFieldsChange,
  onSignInFlowChange,
  onSignOutFlowChange,
  onPortalFlowChange,
  onLayoutChange,
  onPortalLayoutChange,
  onAutoSignOutMethodChange,
  onAutoSignOutValueChange,
  onCancel,
  onSubmit,
  translationsController,
  submitError,
}) {
  const theme = useTheme();
  const { translate, translateEntity } = useLanguageContext();

  return (
    <>
      <OverlayLoader groups="visitor_type_page_fetch">
        <FormContainer
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"visitor_type_page_submit"}
        >
          <InputWrapper
            label={translate("eva.main.entities.location")}
            error={EVAApiHelper.getResponseError("location_id", submitError)}
          >
            <LocationFormSelect
              value={visitorTypeData.location_id}
              onChange={onLocationIdChange}
              disabled={visitor_type !== undefined}
            />
          </InputWrapper>

          <StyledFlexRow style={{ marginTop: theme.spacing.normal }}>
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.name")}
                error={EVAApiHelper.getResponseError("name", submitError)}
                margin={`0px 0px ${theme.spacing.normal}`}
                required
              >
                <StyledInput
                  type="text"
                  placeholder={translate("eva.main.validation.attributes.name")}
                  value={visitorTypeData.name}
                  onChange={onNameChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <InputWrapper
              label={translate("eva.main.validation.attributes.order")}
              error={EVAApiHelper.getResponseError("order", submitError)}
            >
              <StyledInput
                type="number"
                placeholder={translate("eva.main.validation.attributes.order")}
                value={visitorTypeData.order}
                onChange={onOrderChange}
              />
            </InputWrapper>
          </StyledFlexRow>

          <StyledFlexRow style={{ marginBottom: theme.spacing.normal }}>
            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.sign_in_flow_id",
                )}
                required
                error={EVAApiHelper.getResponseError(
                  "sign_in_flow_id",
                  submitError,
                )}
              >
                <Select
                  options={flows.map((flow) => {
                    return { value: flow.id, label: flow.name };
                  })}
                  value={visitorTypeData.sign_in_flow_id}
                  onChange={onSignInFlowChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.sign_out_flow_id",
                )}
                error={EVAApiHelper.getResponseError(
                  "sign_out_flow_id",
                  submitError,
                )}
              >
                <Select
                  options={flows.map((flow) => {
                    return { value: flow.id, label: flow.name };
                  })}
                  nullable={true}
                  value={visitorTypeData.sign_out_flow_id}
                  onChange={onSignOutFlowChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.portal_flow_id",
                )}
                error={EVAApiHelper.getResponseError(
                  "portal_flow_id",
                  submitError,
                )}
              >
                <Select
                  options={flows.map((flow) => {
                    return { value: flow.id, label: flow.name };
                  })}
                  nullable={true}
                  value={visitorTypeData.portal_flow_id}
                  onChange={onPortalFlowChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <StyledFlexRow>
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.layout_id")}
                margin={`0px 0px ${theme.spacing.normal}`}
                error={EVAApiHelper.getResponseError("layout_id", submitError)}
              >
                <Select
                  options={layouts.map((layout) => {
                    return { value: layout.id, label: layout.name };
                  })}
                  nullable={true}
                  value={visitorTypeData.layout_id}
                  onChange={onLayoutChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.portal_layout_id",
                )}
                margin={`0px 0px ${theme.spacing.normal}`}
                error={EVAApiHelper.getResponseError(
                  "portal_layout_id",
                  submitError,
                )}
              >
                <Select
                  options={layouts.map((layout) => {
                    return { value: layout.id, label: layout.name };
                  })}
                  nullable={true}
                  value={visitorTypeData.portal_layout_id}
                  onChange={onPortalLayoutChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <InputWrapper
            label={translate("eva.main.validation.attributes.department_id")}
            error={EVAApiHelper.getResponseError("department_id", submitError)}
            margin={`0px 0px ${theme.spacing.normal}`}
          >
            <Select
              options={departments.map((department) => {
                return { value: department.id, label: department.name };
              })}
              nullable={true}
              value={visitorTypeData.department_id}
              onChange={onDepartmentChange}
            />
          </InputWrapper>

          <StyledFlexRow>
            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.earliest_time",
                )}
                error={EVAApiHelper.getResponseError(
                  "earliest_time",
                  submitError,
                )}
                margin={`0px 0px ${theme.spacing.normal}`}
              >
                <StyledInput
                  type="time"
                  value={visitorTypeData.earliest_time}
                  onChange={onEarliestTimeChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.latest_time")}
                error={EVAApiHelper.getResponseError(
                  "latest_time",
                  submitError,
                )}
                margin={`0px 0px ${theme.spacing.normal}`}
              >
                <StyledInput
                  type="time"
                  value={visitorTypeData.latest_time}
                  onChange={onLatestTimeChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.requires_approval",
            )}
            error={EVAApiHelper.getResponseError(
              "requires_approval",
              submitError,
            )}
            margin={`0px 0px ${theme.spacing.normal}`}
          >
            <Select
              value={visitorTypeData.requires_approval}
              options={[
                { value: true, label: translate("eva.main.general.yes") },
                { value: false, label: translate("eva.main.general.no") },
              ]}
              onChange={onRequiresApprovalChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.returning")}
            error={EVAApiHelper.getResponseError("returning", submitError)}
            margin={`0px 0px ${theme.spacing.normal}`}
          >
            <Select
              value={visitorTypeData.returning}
              options={[
                { value: true, label: translate("eva.main.general.yes") },
                { value: false, label: translate("eva.main.general.no") },
              ]}
              onChange={onReturningChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.identifier_fields",
            )}
            required
            error={EVAApiHelper.getResponseErrorArray(
              "identifier_fields",
              submitError,
              (index) =>
                fields.find(
                  (field) =>
                    field.id === visitorTypeData.identifier_fields[index],
                )?.key,
            )}
          >
            <MultiSelect
              options={fields.map((field) => {
                return {
                  value: field.id,
                  label: translateEntity(field, "label"),
                };
              })}
              value={visitorTypeData.identifier_fields}
              onChange={onIdentifierFieldsChange}
            />
          </InputWrapper>

          {/* Auto sign out */}
          <StyledFlexRow style={{ marginTop: theme.spacing.normal }}>
            <StyledFlexItem>
              <InputWrapper
                label={translate(
                  "eva.main.validation.attributes.auto_sign_out_method",
                )}
                error={EVAApiHelper.getResponseError(
                  "auto_sign_out_method",
                  submitError,
                )}
                required
              >
                <Select
                  value={visitorTypeData.auto_sign_out_method}
                  onChange={onAutoSignOutMethodChange}
                  options={[
                    {
                      value: "disabled",
                      label: translate(
                        "eva.main.validation.values.auto_sign_out_method.disabled",
                      ),
                    },
                    {
                      value: "after",
                      label: translate(
                        "eva.main.validation.values.auto_sign_out_method.after",
                      ),
                    },
                    {
                      value: "at",
                      label: translate(
                        "eva.main.validation.values.auto_sign_out_method.at",
                      ),
                    },
                  ]}
                />
              </InputWrapper>
            </StyledFlexItem>

            {visitorTypeData.auto_sign_out_method !== "disabled" && (
              <StyledFlexItem>
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.auto_sign_out_value",
                  )}
                  error={EVAApiHelper.getResponseError(
                    "auto_sign_out_value",
                    submitError,
                  )}
                  required
                >
                  <StyledInput
                    type={
                      visitorTypeData.auto_sign_out_method === "at"
                        ? "time"
                        : "number"
                    }
                    placeholder={translate(
                      "eva.main.validation.attributes.auto_sign_out_value",
                    )}
                    value={visitorTypeData.auto_sign_out_value || ""}
                    onChange={onAutoSignOutValueChange}
                  />
                </InputWrapper>
              </StyledFlexItem>
            )}
          </StyledFlexRow>
        </FormContainer>
      </OverlayLoader>

      <OverlayLoader groups="visitor_type_page_fetch">
        <EntityTranslationsContainer
          controller={translationsController}
          style={{ marginBlock: theme.spacing.large }}
        >
          <InputWrapper
            label={translate("eva.main.validation.attributes.label")}
            error={translationsController.getTranslationError(
              "label",
              submitError,
            )}
            margin={`0px 0px ${theme.spacing.normal}`}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.label")}
              value={translationsController.getValue("label")}
              onChange={(e) =>
                translationsController.onTranslationChange(
                  e.target.value,
                  "label",
                )
              }
            />
          </InputWrapper>
        </EntityTranslationsContainer>
      </OverlayLoader>
    </>
  );
}

export default VisitorTypePageView;
